import constants from './constants';

const initState = {
  createNewModelInverter: {
    id: '',
    name: '',
    characteristics: {},
  },
  modelInverterIdToEdit: null,
};

function modelInvertersReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_CREATE_EDIT_MODEL_INVERTER:
      // console.log(payload);
      return {
        ...state,
        createNewModelInverter: payload,
      };

    case constants.SET_MODEL_INVERTER_ID_TO_EDIT:
      // console.log(payload);
      return {
        ...state,
        modelInverterIdToEdit: payload,
      };

    default:
      return state;

  }

}

export default modelInvertersReducer;
